module.exports = __webpack_public_path__ + "static/img/img_11.a6cdcb5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/enterprise/images/img_11.webp
// module id = Krju
// module chunks = 4